import {AbstractControlOptions, AsyncValidatorFn, FormControl, ValidatorFn} from "@angular/forms";

export class WriteBackFormControl extends FormControl {
  constructor(
    thisArg: any,
    field: keyof (typeof thisArg),
    validatorOrOpts?: ValidatorFn | ValidatorFn[] | AbstractControlOptions | null,
    asyncValidator?: AsyncValidatorFn | AsyncValidatorFn[] | null,
  ) {
    super(thisArg[field], validatorOrOpts, asyncValidator);

    this.valueChanges.subscribe((value) => {
      thisArg[field] = value;
    });
  }
}
